/**
 * Branded marketing CTA with a restrained directional interaction.
 *
 * The icon rail crosses the label on hover/focus to signal forward motion.
 * The reduced-motion rule in index.css removes the transition for users who
 * request it. Keep this component on public marketing surfaces; dense product
 * workflows should continue to use conventional enterprise buttons.
 */
const BsiqActionButton = ({
  children,
  variant = 'primary',
  className = '',
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    className={`bsiq-action bsiq-action--${variant} ${className}`.trim()}
    {...props}
  >
    <span className="bsiq-action__rail" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d="M7 6h2v2H7V6Zm3 3h2v2h-2V9Zm3 3h2v2h-2v-2Zm-3 3h2v2h-2v-2Zm-3 3h2v2H7v-2Z" />
      </svg>
    </span>
    <span className="bsiq-action__label">{children}</span>
  </button>
);

export default BsiqActionButton;
